import { useState } from 'react';

import { useMapboxScript } from '@spotahome/marketplace-common/src/utils/mapbox-script';

import InteractiveMap from './InteractiveMap.mapbox';

const InteractiveMapContainer = props => {
  const [isMapLoaded, setIsMapLoaded] = useState(false);

  useMapboxScript(() => setIsMapLoaded(true));

  return isMapLoaded ? <InteractiveMap {...props} /> : null;
};

export default InteractiveMapContainer;
